import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalErrorService } from '@services/global-error.service';
import { catchError, Observable } from 'rxjs';
import { jobDtlsResponse } from '@interfaces/job-details.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OpsJobDetailsService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorService
  ) {}

  getJobDetails(hiringRequestId: number): Observable<jobDtlsResponse> {
    return this.http
      .get<jobDtlsResponse>(`${this.baseUrl}/ops/open-positions/${hiringRequestId}`)
      .pipe(
        catchError((error) => {
          return this.errorHandler.logError(error);
        })
      );
  }
}
